import $ from 'jquery';

// eslint-disable-next-line no-undef
const object = vipersObject;

$('.vds-block-single').each(function () {
    const current = $(this);
    const id = current.attr('data-block');
    const desktopWrapper = current.find(
        '.vds-block-desktop .vds-block-content-inner'
    );
    const mobileWrapper = current.find(
        '.vds-block-mobile .vds-block-content-inner'
    );
    const data = {
        vars: window[`${id}`],
        action: 'vipers_ad_block',
        nonce: object.nonce,
    };

    $.ajax({
        url: object.ajaxUrl,
        type: 'POST',
        dataType: 'JSON',
        data,
        success: (res) => {
            if (res.success) {
                setTimeout(() => {
                    desktopWrapper.html(res.data.desktopContent);
                    mobileWrapper.html(res.data.mobileContent);
                }, 1000);
            }
        },
    });
});

$('.vds-block-double').each(function () {
    const current = $(this);
    const id = current.attr('data-block');
    const wrapper = current.find('.vds-block-content');
    const data = {
        vars: window[`${id}`],
        action: 'vipers_ad_double_block',
        nonce: object.nonce,
    };

    $.ajax({
        url: object.ajaxUrl,
        type: 'POST',
        dataType: 'JSON',
        data,
        success: (res) => {
            if (res.success) {
                setTimeout(() => {
                    wrapper.html(res.data.content);
                }, 1000);
            }
        },
    });
});
